main.navigation = (function () {
    var header = document.getElementsByClassName('js-header')[0];
    var menu = document.getElementsByClassName('js-nav-menu')[0];
    var toggle = document.getElementsByClassName('js-nav-toggle')[0];
    var isOpen = null;
    var body = document.getElementsByTagName('body')[0];
    var html = document.documentElement;

    var init = function () {
        isOpen = main.utils.viewport().width > 768;
        _eventHandler();
        setA11YLabels();
    };

    /**
     * main.navigation.eventHandler() mobile toggle button click event
     * Toggles active class & A11Y labels
     */
    var _eventHandler = function () {
        toggle.addEventListener('click', function () {
            main.utils.toggleClass(header, 'is-active');
            main.utils.toggleClass(menu, 'is-active');
            main.utils.toggleClass(toggle, 'is-active');
            main.utils.toggleClass(body, 'no-scroll');
            main.utils.toggleClass(html, 'no-scroll');
            _toggleA11YLabels();
        });
    };

    /**
     * main.navigation.setA117Labels() set accessibility labels
     * based on viewport width
     */
    var setA11YLabels = function () {
        isOpen = main.utils.viewport().width > 768;
        toggle.setAttribute('aria-expanded', String(isOpen));
        menu.setAttribute('aria-hidden', String(!isOpen));
    };

    /**
     * main.navigation.toggleA11YLabels() toggles accessibility labels
     * based on the state of the navigation
     */
    var _toggleA11YLabels = function () {
        toggle.setAttribute('aria-expanded', String(!isOpen));

        isOpen = !isOpen;
        menu.setAttribute('aria-hidden', String(isOpen));
    };

    /**
     * main.navigation.close() removes active class on navigation
     */
    var close = function () {
        main.utils.removeClass(header, 'is-active');
        main.utils.removeClass(menu, 'is-active');
        main.utils.removeClass(toggle, 'is-active');
        main.utils.removeClass(body, 'no-scroll');
        main.utils.removeClass(html, 'no-scroll');
    };

    return {
        init: init,
        setA11YLabels: setA11YLabels,
        close: close
    };

})();
